import { sendCaptureEvent } from "./sentryHelpers";
export function setupGlobalErrorHandlers() {
  window.onerror = (message, source, lineno, colno, error) => {
    sendCaptureEvent({message, source, lineno, colno, error}, "Global JS error")
  };

  window.onunhandledrejection = (event) => {
    sendCaptureEvent(event, "Unhandled promise error")
  };
}